






































import { Component, Vue } from 'vue-property-decorator'
import { Project } from '@/api/model/project'
import { ProjectAPI } from '@/api/backend-client'
import { ProjectEmailTemplate } from '@/api/model/project-email-template'
import { v4 as uuid } from 'uuid'
import { escapeHtml } from '@/helpers/html'

export interface CreateProjectFormModel {
    name: string,
    active: boolean,
}

@Component
export default class ProjectsCreate extends Vue {
    submitting: boolean = false
    createProjectForm: CreateProjectFormModel = {
        name: null,
        active: true,
    }

    resetForm(): void {
        this.createProjectForm = {
            name: null,
            active: true,
        }
    }

    generateProjectEmailTemplate(type: string): ProjectEmailTemplate {
        return ProjectEmailTemplate.fromData({
            type,
            senderName: this.$currentCompany.name,
            senderEmail: 'info',
            subject: this.$t(`project-email-template.${type}.subject`),
            body: this.$t(`project-email-template.${type}.body`),
        })
    }

    async createProject(): Promise<void> {
        try {
            this.submitting = true
            const project = Project.fromData({
                company: this.$currentCompany.resourceIdentifier,
                id: uuid(),
                name: this.createProjectForm.name,
                mortgageService: null,
                appraisalService: null,
                emailTemplates: [
                    this.generateProjectEmailTemplate('project-services-introduction'),
                    this.generateProjectEmailTemplate('mortgage-monthly-cost-calculaton'),
                    this.generateProjectEmailTemplate('mortgage-meeting-request-confirmation'),
                    this.generateProjectEmailTemplate('appraisal-request-confirmation'),
                ],
                active: this.createProjectForm.active,
            })

            await ProjectAPI.create(project)
            await this.goBackToLister()

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })

        } finally {
            this.submitting = false
        }
    }

    async goBackToLister(): Promise<void> {
        await this.$router.push({
            name: 'projects_list',
        })
    }
}
